export default {"src":"/_next/static/media/Featured3.1d4a511b.svg","height":56,"width":56};